enum ModelNameEnum {
  airtableids = 'airtableids',
  amounttier = 'amounttier',
  authorization = 'authorization',
  batchjoblog = 'batchjoblog',
  classyteam = 'classyteam',
  component = 'component',
  configuration = 'configuration',
  donation = 'donation',
  emailtemplate = 'emailtemplate',
  event = 'event',
  field = 'field',
  invitecode = 'invitecode',
  item = 'item',
  model = 'model',
  order = 'order',
  page = 'page',
  pendingdonation = 'pendingdonation',
  registrationtype = 'registrationtype',
  token = 'token',
  user = 'user',
}

export default ModelNameEnum;
